const translations = {
  name: 'Nombre',
  slaType: 'Tipo SLA',
  duration: 'Duración',
  slaUnit: 'Unidad SLA',
  checklists: 'Cuestionarios',
  places: 'Lugares',
  createdAt: 'Creado en',
  emptyMessage: 'No se encontraron datos',
  'slaUnits.day': 'Días',
  'slaUnits.hour': 'Horas',
  'slaUnits.minute': 'Minutos',
  'slaTypes.creationDate': 'Fecha de apertura',
  'slaTypes.schedulingDate': 'Fecha de agendamiento',
  'header.title': 'Configuraciones de SLA',
  'header.subtitle': 'Gestione las configuraciones de SLA del sistema: visualice, cree o edite según sea necesario.',
  'header.newConfig': 'Nueva configuración',
  'modal.listTitle': 'Configuraciones de SLA',
  'modal.editTitle': 'Editar SLA',
  'modal.newTitle': 'Nuevo SLA'
}

export default translations
